<template>
  <v-navigation-drawer
    disable-resize-watcher
    class="drawer"
    :value="storeDrawer"
    @input="changeDrawer"
    style="position:fixed; top:0; left:0; overflow-y:scroll;"
  >
    <div>
      <v-card flat color="#f5f5f5" class="title text-xs-left" v-if="storeAuth.authorized === false">
        <v-card-text class="pb-2">
          <span v-if="$VENDOR === 'resol'">VBus.net</span>
          <span v-if="$VENDOR === 'mtf'">DVM Cloud Service </span>
        </v-card-text>
      </v-card>
      <v-divider></v-divider>
      <v-list dense class="pt-0" v-if="storeAuth.authorized === false">
        <v-list-tile :to="{name: 'Login'}">
          <v-list-tile-action>
            <v-icon>fa-sign-in fa-fw</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ $t('general.login') }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile :to="{name: 'ForgotPassword'}">
          <v-list-tile-action>
            <v-icon>fa-key fa-fw</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ $t('general.forgotYourPassword') }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile :to="{name: 'Register'}">
          <v-list-tile-action>
            <v-icon>fa-envelope-o fa-fw</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ $t('general.register') }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>

      <div v-for="(item, key) in menuItems" :key="key">
        <v-divider></v-divider>
        <v-card flat color="#f5f5f5" class="title text-xs-left">
          <v-card-text class="pb-2" v-html="$t(item.title)"></v-card-text>
        </v-card>
        <v-divider></v-divider>
        <v-list dense class="pt-0">
          <v-list-tile v-for="subItem in item.items" :key="subItem.name" :to="{name: subItem.action}">
            <v-list-tile-action>
              <span
                v-if="subItem.name === 'sideBar.liveSchemes'"
                class="resol-Aussentemperatur"
                style="font-size:21px;margin-left:2px"
              ></span>
              <span v-else-if="subItem.name === 'general.messages'">
                <v-badge
                  v-if="storeUser && storeUser.newMessages"
                  color="red"
                  overlap
                >
                  <template v-slot:badge>
                    <span>&nbsp;</span>
                  </template>
                  <v-icon>
                    {{ subItem.icon }}
                  </v-icon>
                </v-badge>
                <v-icon
                  v-else
                >
                  {{ subItem.icon }}
                </v-icon>
              </span>
              <v-icon v-else>{{ subItem.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ $t(subItem.name) }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-list dense class="pt-0" v-if="key === menuItems.length - 1 && storeAuth.authorized">
          <v-divider></v-divider>
          <v-list-tile @click="logout(true)">
            <v-list-tile-action>
              <v-icon>fa-sign-in fa-fw</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ $t('general.logout') }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </div>

      <div>
        <v-divider></v-divider>
        <v-card flat color="#f5f5f5" class="title text-xs-left">
          <v-card-text class="pb-2">Tools</v-card-text>
        </v-card>
        <v-divider></v-divider>

        <v-list dense class="pt-0">
          <v-list-tile
            v-if="$VENDOR === 'resol'"
            :to="{name: 'DiscoveryTool'}"
          >
            <v-list-tile-title>
              {{ $t('discoveryTool.title') }}
            </v-list-tile-title>
          </v-list-tile>
          <v-list-tile
            v-if="$VENDOR === 'resol'"
            :to="{name: 'DataViewer'}"
          >
            <v-list-tile-title>
              VBus<sup>®</sup> Data Viewer
            </v-list-tile-title>
          </v-list-tile>
          <v-list-tile
            v-if="$VENDOR === 'resol'"
            href="https://www.vbus.net/setup/"
            target="_blank"
          >
            <v-list-tile-title>
              {{ $t('onboardingAssistant') }}
            </v-list-tile-title>
          </v-list-tile>
          <v-list-tile
            v-if="$VENDOR === 'resol'"
            href="https://rosa.resol.de/#/"
            target="_blank"
          >
            <v-list-tile-title>
              ROSA
            </v-list-tile-title>
          </v-list-tile>
          <v-list-tile
            v-if="storeUser && storeUser.isProfessional && storeUser.valid_ownership_count > 0"
            :to="{name: 'Parameterization'}"
          >
            <v-list-tile-title>
              {{ $t('sideBar.parametrization') }}
            </v-list-tile-title>
          </v-list-tile>
          <v-list-tile
            v-if="$VENDOR === 'resol' && storeUser && storeUser.isProfessional"
            :to="{name: 'SettingsDocumentationGenerator'}"
          >
            <v-list-tile-title>
              {{ $t('settingsDocumentation.settingsDocumentationGenerator') }}
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </div>

    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    menuItems: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'storeAuth',
      'storeDrawer',
      'storeUser'
    ])
  },
  methods: {
    changeDrawer (value) {
      this.$store.commit('setDrawer', value)
    },
    logout (closeDrawer) {
      this.$store.commit('setAuthorization', false)
      this.$store.commit('setUser', null)
      localStorage.removeItem('VBus.net-JWT')
      if (closeDrawer) {
        this.$store.commit('setDrawer', false)
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/client/components/Navigation/Drawer.vue